import { Link, useLocation } from "react-router-dom";

export default function MarketingHeader() {
  const { pathname } = useLocation();
  const link = (to, label, testId) => (
    <Link
      to={to}
      data-testid={testId}
      className={`px-3 py-2 rounded-full text-sm font-medium transition-colors ${
        pathname === to ? "text-[#2C302E] bg-[#F2EFEB]" : "text-[#59605C] hover:text-[#2C302E]"
      }`}
    >
      {label}
    </Link>
  );
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#EFE9DE]/85 border-b border-[#D8CFB9]">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-4 flex items-center justify-between">
        <Link to="/" data-testid="marketing-logo" className="flex items-baseline gap-2.5 group min-w-0 shrink">
          <span className="w-9 h-9 self-center rounded-full bg-[#4A6148] flex items-center justify-center text-white font-wordmark tracking-tight text-[11px] font-bold leading-none group-hover:bg-[#3B5B3E] transition-colors shrink-0">
            WYB
          </span>
          <span className="hidden sm:inline font-wordmark text-[#2C302E] text-base sm:text-lg leading-none tracking-tight truncate">
            WhatsYourBalance<span className="font-wordmark-italic text-[#4A6148] text-[0.72em] ml-[1px]">.com</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {link("/", "Home", "nav-home")}
          {link("/pricing", "Pricing", "nav-pricing")}
          {link("/faq", "FAQ", "nav-faq")}
        </nav>
        <div className="flex items-center gap-2 shrink-0">
          <Link to="/login" data-testid="nav-login" className="btn-ghost text-sm whitespace-nowrap">
            Log in
          </Link>
          <Link to="/signup" data-testid="nav-signup" className="btn-primary text-sm whitespace-nowrap">
            <span className="hidden sm:inline">Start free trial</span>
            <span className="sm:hidden">Try free</span>
          </Link>
        </div>
      </div>
    </header>
  );
}
